import { sosHttpInstance } from './httpClient';
import {
  RELEASE_ENDPOINTS,
  buildFilterDataEndpoint,
} from '@/constants/apiEndpoints';

// SOS: Fetch all RESOURCE_ALL_INFO
export const getReleaseDashboardDetailsApi = async (body) => {
  const response = await sosHttpInstance.post(
    RELEASE_ENDPOINTS.DASHBOARD,
    body,
  );

  return response.data;
};

export const sosReleaseDetailsListApi = async (body) => {
  const response = await sosHttpInstance.post(
    RELEASE_ENDPOINTS.LIST + '?page=' + body.page + '&size=100',
    body,
  );
  return response.data;
};

export const sosReleaseDetailsCalendarListApi = async (body, month, year) => {
  const response = await sosHttpInstance.post(
    RELEASE_ENDPOINTS.CALENDAR + '?month=' + month + '&year=' + year,
    body,
  );
  return response.data;
};

export const fetchReleaseManagementFiltersApi = async () => {
  const response = await sosHttpInstance.get(
    buildFilterDataEndpoint('release'),
  );
  return response.data.RELEASE_PAGE;
};

export const releaseSummaryApi = async (releaseId) => {
  const response = await sosHttpInstance.get(
    RELEASE_ENDPOINTS.HEAD + releaseId,
  );
  return response.data;
};

export const getReleaseSupportDashboardDetailsApi = async (body) => {
  const response = await sosHttpInstance.post(
    RELEASE_ENDPOINTS.SUPPORT_DASHBOARD,
    body,
  );

  return response.data;
};
